import UtilityMixin from "../../utility/UtilityMixin";
export default {
	mixins: [UtilityMixin],
	methods: {
		loadDataPriorita() {
			let me = this;
			let pathResourcePriorita = "/gestioneattivitapriorita";
			UtilityMixin.methods.loadDataResources(pathResourcePriorita, {}, me.loadDataPrioritaSuccess, me.loadDataPrioritaError);
		},
		loadDataPrioritaSuccess(resposne) {
			let me = this;
			me.tipoPrioritaOptions = resposne.data.data.list;
		},

		loadDataPrioritaError(error) {
			console.log(error);
		},
	},
};
